import { render, staticRenderFns } from "./brokerageLog.vue?vue&type=template&id=5891ee5c&scoped=true"
import script from "./brokerageLog.vue?vue&type=script&lang=js"
export * from "./brokerageLog.vue?vue&type=script&lang=js"
import style0 from "./brokerageLog.vue?vue&type=style&index=0&id=5891ee5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891ee5c",
  null
  
)

export default component.exports